import React from "react";

const HotelOwners = () => {
  return (
    <>
      <section class="innerpage-wrapper">
        <div id="forgot-password" class="innerpage-section-padding">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="custom-form custom-form-fields">
                  <h3>Hotel Owners</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HotelOwners;
